import { CorporateProfile } from './CorporateProfile';
import { DealersCPF } from './DealersCPF';
import { CPF } from './CPF';
import { NationalAccount } from './NationalAccount';
import { CorporateAccountRequestStatus } from './CorporateAccountRequestStatus';
import { ApprovalWorkflow } from './ApprovalWorkflow';
import { NationalCPF } from './NationalCPF';
import { CorporateSegment } from './CorporateSegment';
import { FollowupEmailConfig } from './FollowupEmailConfig';

export const menu = {
	name: 'Oem',
	list: [
		{ name: 'NationalAccount', route: NationalAccount.name },
		{ name: 'AssignCPF', route: CPF.name },
		{ name: 'CorporateProfile', route: CorporateProfile.name },
		{ name: 'DealersCPF', route: DealersCPF.name },
		{ name: 'NationalCPF', route: NationalCPF.name },
		{ name: 'CorporateAccountRequestStatus', route: CorporateAccountRequestStatus.name },
		{ name: 'FollowupEmailConfig', route: FollowupEmailConfig.name },
		ApprovalWorkflow.menu,
		CorporateSegment.menu,
	],
};
